import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Header = styled.div`
  display: flex;
  padding: 40px 50px 20px 50px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

export const Title = styled(Typography.Header).attrs(() => ({
  $variant: '2',
}))`
  flex: 1;
  font-size: 22px;
`;

export const CloseButton = styled.button`
  width: 20px;
  height: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  background: none;
  box-shadow: none;
`;

export const Content = styled.div`
  display: flex;
  padding: 5px 50px;
  flex-direction: column;
  gap: 25px;
`;

export const Subtitle = styled(Typography.Body)`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const ActionWrapper = styled.div`
  padding: 30px 50px 50px;
`;
